import React from 'react';
import lodash from 'lodash';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import FieldSet from '../../../../fieldset/FieldSet';
import SearchBar from '../../../../searchbar/SearchBar';
import Grid from '../../../../grid/Grid';
import AsyncActionButton from '../../../../button/AsyncActionButton';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import UtilitiesService from '../../../../../service/UtilitiesService';
import GRWaterDetailedAccountModal from './GRWaterDetailedAccountModal';
import GRWaterDetailedBillModal from './GRWaterDetailedBillModal';
import AccountLinkForm from '../../../../form/AccountLinkForm';
import AutoPayForm from '../../../../form/AutopayForm';

class GRWater extends React.Component {
  constructor(props) {
    super(props);
    this.GR_WATER = 'gr_water';

    this.state = {
      accountHeaders: [],
      accountRows: [],
    };

    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'External Account ID',
      },
      {
        value: 'customerId',
        display: 'Customer ID',
      },
    ];
  }

  onAccountRowSelect(selectedRow) {
    const { accountRows, selectedAccount, } = this.state;

    if (selectedAccount && selectedAccount.id !== selectedRow.id) {
      this.resetBills();
    }

    const account = accountRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedAccount: account.raw,
    });
  }

  onBillRowSelect(selectedRow) {
    const { billRows, } = this.state;
    const selectedBill = billRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedBill: selectedBill.raw,
    });
  }

  onClick(event) {
    this.reset();
    const { combo, search, } = event;
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = this.GR_WATER;

    const headerInclusions = item => ![ 'mongoId', 'className', 'customerIds', 'serviceOfferingId', ].includes(item);

    UtilitiesService.getUtilityAccountBySearch(criteria)
      .then((response) => {
        const { accounts, } = response.data;
        const model = Grid.toModelFromList(accounts, {
          headerFormatter: value => lodash.startCase(value.header),
          filter: headerInclusions,
        });

        this.setState({
          accountHeaders: model.headers,
          accountRows: model.format(accounts),
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  onBillClick(accountId) {
    this.resetBills();
    this.setState({
      isBillLoading: true,
    });
    const rows = [];
    let headers = [];
    const criteria = {};
    criteria.accountId = accountId;
    criteria.serviceOfferingId = this.GR_WATER;

    UtilitiesService.getUtilityBillBySearch(criteria)
      .then((response) => {
        const { bills, } = response.data;
        const rowInclusions = item => [ 'id', 'paid', 'dueDate', 'newestBill', 'invoiceNumber', 'billAmount', ].includes(item);

        if (bills !== null && bills.length > 0) {
          const formattedBills = bills.map((account) => {
            const values = ObjectUtils.filterObject(account, rowInclusions);
            return values;
          });
          headers = Object.keys(formattedBills[0].value).map(key => ({
            display: lodash.startCase(key),
            value: key,
          }));

          formattedBills.forEach((bill) => {
            rows.push({
              value: Object.values(bill.value),
              raw: bill.raw,
            });
          });
        }

        this.setState({
          billHeaders: headers,
          billRows: rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setState({ isBillLoading: false, });
      });
  }

  resetBills() {
    this.setState({
      billHeaders: [],
      billRows: [],
      selectedBill: null,
    });
  }

  showSelectedAccountDetails(selectedAccount) {
    const { isBillLoading, } = this.state;
    if (!selectedAccount) {
      return null;
    }
    return (
      <div className="container-fluid">
        <p>{`Selected ID: ${selectedAccount.id}`}</p>
        <hr />
        <div className="row">
          <span className="m-1">
            <GRWaterDetailedAccountModal account={selectedAccount} />
          </span>
          <span className="m-1">
            <AsyncActionButton
              onClick={() => this.onBillClick(selectedAccount.id)}
              contents="Show Bills"
              isLoading={isBillLoading}
              variant="primary"
              loadingVariant="secondary"
            />
          </span>
          <span className="m-1">
            <AccountLinkForm
              title="Link/Unlink Customers"
              id={selectedAccount.id}
              customerIds={ObjectUtils.formatStringAsJSONArray(selectedAccount.customerIds)}
              serviceOfferingId={this.GR_WATER}
            />
          </span>
          <span className="m-1">
            <AutoPayForm
              title="Manage Autopay"
              accountId={selectedAccount.id}
              serviceOfferingId={this.GR_WATER}
              autopayId={selectedAccount.autopayId}
            />
          </span>
        </div>
      </div>
    );
  }

  showSelectedBillDetails(selectedBill) {
    if (!selectedBill) {
      return null;
    }
    return (
      <div>
        <p>{`Selected ID: ${selectedBill.id}`}</p>
        <hr />
        <GRWaterDetailedBillModal bill={selectedBill} />
      </div>
    );
  }

  reset() {
    this.setState({
      accountHeaders: [],
      accountRows: [],
      billHeaders: [],
      billRows: [],
      selectedAccount: null,
      selectedBill: null,
    });
  }

  render() {
    const {
      accountHeaders = [],
      accountRows = [],
      billHeaders = [],
      billRows = [],
      selectedAccount,
      selectedBill,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.onClick(data)}
          style={{ maxHeight: '300px', }}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Water Accounts">
            <Grid
              headers={accountHeaders}
              rows={accountRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onAccountRowSelect(row)}
              style={{ maxHeight: '300px', }}
            />
          </FieldSet>
          {this.showSelectedAccountDetails(selectedAccount)}
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="Water Bills" style={{ maxHeight: '300px', }}>
            <Grid
              headers={billHeaders}
              rows={billRows}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
              onRowSelect={row => this.onBillRowSelect(row)}
            />
          </FieldSet>
          {this.showSelectedBillDetails(selectedBill)}
        </div>
      </div>
    );
  }
}

export default GRWater;
